////////LIBRARY/////////
import ActionsTypes from '../../constants/ActionsTypes'

const initKioskCreationImplantation = {
	postKioskImplantation: (filters = {}, requestId, queryParams = { page: '0', size: '250' }) => ({
		type: ActionsTypes.POST_KIOSK_IMPLANTATION,
		payload: {
			filters,
			requestId,
			queryParams,
		},
	}),
	postKioskImplantationSuccess: (data, id) => ({
		type: ActionsTypes.POST_KIOSK_IMPLANTATION_SUCCESS,
		payload: {
			data,
			id,
		},
	}),
	postKioskImplantationFailure: (error) => ({
		type: ActionsTypes.POST_KIOSK_IMPLANTATION_FAILURE,
		payload: {
			error,
		},
	}),
	getItemsCatalogGrowth: (requestId, requestUrl) => ({
		type: ActionsTypes.GET_ITEMS_CATALOG_GROWTH,
		payload: {
			requestId,
			requestUrl,
		},
	}),
	getItemsCatalogGrowthSuccess: (data) => ({
		type: ActionsTypes.GET_ITEMS_CATALOG_GROWTH_SUCCESS,
		payload: {
			data,
		},
	}),
	getItemsCatalogGrowthFailure: (error) => ({
		type: ActionsTypes.GET_ITEMS_CATALOG_GROWTH_FAILURE,
		payload: {
			error,
		},
	}),

	putUnitActionWithId: (toast, caseList, requestId, query, arg = '') => ({
		type: ActionsTypes.PUT_UNIT_ACTION_WITH_ID,
		payload: {
			toast,
			caseList,
			requestId,
			query,
			arg,
		},
	}),
	putUnitActionWithIdSuccess: (data) => ({
		type: ActionsTypes.PUT_UNIT_ACTION_WITH_ID_SUCCESS,
		payload: {
			data,
		},
	}),
	putUnitActionWithIdFailure: (error) => ({
		type: ActionsTypes.PUT_UNIT_ACTION_WITH_ID_FAILURE,
		payload: {
			error,
		},
	}),

	putValidateImplantation: (requestId, redirectTest) => ({
		type: ActionsTypes.PUT_VALIDATE_IMPLANTATION,
		payload: {
			requestId,
			redirectTest,
		},
	}),
	putValidateImplantationSuccess: (data) => ({
		type: ActionsTypes.PUT_VALIDATE_IMPLANTATION_SUCCESS,
		payload: {
			data,
		},
	}),
	putValidateImplantationFailure: (error) => ({
		type: ActionsTypes.PUT_VALIDATE_IMPLANTATION_FAILURE,
		payload: {
			error,
		},
	}),
	resetDataImplantation: () => ({
		type: ActionsTypes.RESET_DATA_IMPLANTATION,
	}),

	resetErrorImplantation: (bool) => ({
		type: ActionsTypes.RESET_ERROR_IMPLANTATION,
		payload: {
			bool,
		},
	}),
	setStoredDatas: (arr) => ({
		type: ActionsTypes.SET_STORED_DATAS,
		payload: {
			arr,
		},
	}),
}

export default initKioskCreationImplantation
